module.exports = __webpack_public_path__ + "static/media/lexia_logo_960x160.e5cae7d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lexia_logo_960x160.jpg
// module id = ./src/assets/lexia_logo_960x160.jpg
// module chunks = 0